export default {

    mounted: function() {
        if(!this.loan) {
            return;
        }
        
        this.addTagToLoan(this.loan);
    },

    methods: {
        addTagToLoan(loan) {
            let data = {
                'loan': loan.id,
            };

            if(loan.round_sky_application) {
                data.source = 'roundsky';
            }

            if(loan.leads_market_application) {
                data.source = 'leadsmarket';
            }

            if(loan.common_leads_market_place_application) {
                data.source = loan.common_leads_market_place_application.source;
            }
            if(loan.source == 'leadgen_sales') {
                data.source = 'leadgen_sales';
            }
            
            window.axios.post('/loan/tag/apply', data).then((response) => {
                console.log(response);
            });
        },
    },
}